import React from 'react';
import bemHelper from 'react-bem-helper';
import './styles.scss';

import Svg from '../../../../subComponents/svg';
import starIcon from '../../../../lib/icons/star.svg';

const bem = bemHelper({ prefix: 'toga-', name: 'storefront-rating' });

class RatingModule extends React.Component {
  render() {
    const { className, rating } = this.props;
    const RANGE = 5;

    return (
      <div className={className}>
        {[...new Array(RANGE)].map((x, index) => {
          return <Svg key={index} markup={starIcon} {...bem('star', { full: rating > index })} />;
        })}
      </div>
    );
  }
}

RatingModule.propTypes = {
  rating: React.PropTypes.number,
};

export default RatingModule;



// WEBPACK FOOTER //
// ./src/components/storefront/components/RatingModule/RatingModule.js